import { User } from '../models/user';

export const userReducer = (state: User = new User()) => {
    return state;
};
